import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import GenericError from './pages/Errors/GenericError';

import 'pure-react-carousel/dist/react-carousel.es.css';

import './translate/i18n';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(
  <React.StrictMode>
    {/*
      Boundary de último recurso: pega crashes dentro dos próprios providers
      (Auth, Toast, Modal) e do BrowserRouter. Por isso o fallback é
      `standalone` — não pode depender de nenhum contexto nem do router.
    */}
    <ErrorBoundary fallback={<GenericError standalone />}>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
